import { Extension } from '@tiptap/core';
import { menuControlFor, toolbarFor } from './_get_menu_control';

const dimensionZero = [undefined, '', '0', '0pt', '0px'];

const activeBlockType = (editor) => (editor.isActive('heading') ? 'heading' : 'paragraph');

const marginValue = (editor, side) => {
  const margin = editor.getAttributes(activeBlockType(editor)).margin || {};
  return parseInt(margin[side], 10) || 0;
};

// Reflect the current block's margins on the toolbar's paragraph-spacing controls.
const syncMenu = ({ editor }) => {
  ['top', 'bottom'].forEach((side) => {
    const value = marginValue(editor, side);
    const slider = menuControlFor(editor, `margin:${side}:set`);
    const display = toolbarFor(editor)?.querySelector(`[data-margin-display="${side}"]`);

    slider && (slider.value = value);
    display && (display.textContent = `${value}px`);
  });
};

const Margins = Extension.create({
  name: 'margin',
  onCreate: syncMenu,
  onSelectionUpdate: syncMenu,
  onTransaction: syncMenu,
  addGlobalAttributes() {
    return [
      {
        types: ['paragraph', 'heading'],
        attributes: {
          margin: {
            default: {},
            renderHTML: (attributes) => {
              let style = '';
              const { top, right, bottom, left } = attributes.margin;

              !dimensionZero.includes(top) && (style += `margin-top: ${top}; `);
              !dimensionZero.includes(right) && (style += `margin-right: ${right}; `);
              !dimensionZero.includes(bottom) && (style += `margin-bottom: ${bottom}; `);
              !dimensionZero.includes(left) && (style += `margin-left: ${left}; `);

              return style ? { style } : {};
            },
            parseHTML: (element) => {
              const style = element.style;
              const margin = {
                top: style.marginTop,
                right: style.marginRight,
                bottom: style.marginBottom,
                left: style.marginLeft,
              };
              return margin;
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      setMargin:
        (options) =>
        ({ commands, editor }) => {
          const type = activeBlockType(editor);
          const margin = editor.getAttributes(type).margin;
          return commands.updateAttributes(type, {
            margin: { ...margin, ...options },
          });
        },
    };
  },
});

export default [Margins];
